import type { MutationContext } from "../domain/commands";

export function mutationContext(expectedVersion?: number): MutationContext {
  return expectedVersion === undefined
    ? { clientMutationId: crypto.randomUUID() }
    : { clientMutationId: crypto.randomUUID(), expectedVersion };
}
